import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MuiFormLabel from '@material-ui/core/FormLabel';
import MuiInput, { InputProps } from '@material-ui/core/Input';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const Input = withStyles({
  root: {
    width: '100%',
  },
})(MuiInput);

const FormLabel = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.black,
    width: '100%',
  },
}))(MuiFormLabel);

const useStyles = makeStyles((theme) => ({
  labelContainer: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      width: 70,
      marginRight: theme.spacing(),
    },
  },
  labelContainerRight: {
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(2),
  },
  inputContainer: ({ fullWidth }: { fullWidth?: boolean }) => ({
    flexGrow: fullWidth ? 1 : 0,
  }),
  grow: {
    flexGrow: 1,
  },
}));

export type Props = InputProps & {
  error?: boolean;
  helperText?: string;
  label?: string;
  fullWidth?: boolean;
  alignRight?: boolean;
  labelRight?: string;
};

export default function InlineTextField({
  alignRight = false,
  error = false,
  fullWidth = false,
  helperText,
  label,
  labelRight,
  ...InputProps
}: Props) {
  const classes = useStyles({ fullWidth });

  return (
    <FormControl error={error} fullWidth={fullWidth || alignRight}>
      <div style={{ display: 'flex' }}>
        <div className={classes.labelContainer}>
          <FormLabel>{label}</FormLabel>
        </div>

        {alignRight && <div className={classes.grow} />}

        <div className={classes.inputContainer}>
          <Input fullWidth={fullWidth || alignRight} {...InputProps} />
          <FormHelperText>{helperText}</FormHelperText>
        </div>

        {labelRight && (
          <div className={classes.labelContainerRight}>
            <FormLabel>{labelRight}</FormLabel>
          </div>
        )}
      </div>
    </FormControl>
  );
}
